(() => {
  if (window.BagspotWatchDeals) return;
  const controllers = new Set();
  const storagePrefix = 'bagspot.watch-deal.v1.';
  const goodId = n => Number.isSafeInteger(Number(n)) && Number(n) > 0;
  const safeImage = src => { try { const u = new URL(src, location.origin); return u.protocol === 'https:' && (u.hostname === 'cdn.shopify.com' || u.hostname === location.hostname) ? u.href : ''; } catch { return ''; } };
  class WatchDeals {
    constructor(root) {
      this.root = root;
      this.c = JSON.parse(root.querySelector('[data-watch-deal-config]').textContent);
      this.t = this.c.text;
      this.key = storagePrefix + this.c.collection;
      this.products = new Map(this.c.products.map(p => [String(p.id), p]));
      this.state = {offer: 'five', items: []};
      this.busy = false;
      this.money = n => new Intl.NumberFormat(this.c.locale || 'en', {style: 'currency', currency: this.c.currency || 'PKR', maximumFractionDigits: 0}).format(n / 100);
      this.load();
      const offer = new URL(location.href).searchParams.get('deal');
      if (this.c.offers.some(o => o.id === offer) && !this.state.items.length) this.state.offer = offer;
      this.root.addEventListener('click', e => this.click(e));
      this.root.addEventListener('input', e => { if (e.target.matches('[data-deal-search]')) this.filter(e.target.value); });
      this.root.addEventListener('change', e => { if (e.target.matches('[data-deal-variant]')) this.variantChanged(e.target.closest('[data-deal-card]')); this.updateProductButton(); });
      if (this.c.mode === 'product') {
        this.section = document.getElementById('ProductSection-' + root.dataset.productSection);
        this.section?.addEventListener('change', () => setTimeout(() => this.updateProductButton(), 0));
        const form = this.section?.querySelector('form[action*="/cart/add"]');
        if (form) new MutationObserver(() => this.updateProductButton()).observe(form, {subtree: true, attributes: true, attributeFilter: ['value', 'disabled']});
      }
      this.update();
      this.rewriteLinks();
      const tray = this.root.querySelector('[data-deal-tray]');
      if (typeof ResizeObserver !== 'undefined') new ResizeObserver(() => document.documentElement.style.setProperty('--wd-tray-height', tray.getBoundingClientRect().height + 'px')).observe(tray);
      this.root.dataset.ready = 'true';
    }
    get offer() { return this.c.offers.find(o => o.id === this.state.offer) || this.c.offers[1]; }
    load() {
      try {
        const saved = localStorage.getItem(this.key) || (this.c.collection === 'watch-deals' ? localStorage.getItem(storagePrefix + 'watches') : null);
        const s = JSON.parse(saved);
        if (!s || !this.c.offers.some(o => o.id === s.offer) || !Array.isArray(s.items)) return;
        const items = s.items.filter(i => goodId(i.id) && goodId(i.productId) && /^[a-z0-9][a-z0-9-]*$/.test(i.handle) && typeof i.title === 'string' && typeof i.variant === 'string' && Number.isFinite(i.price)).slice(0, 5).map(i => ({id: Number(i.id), productId: Number(i.productId), handle: i.handle, title: i.title.slice(0, 200), variant: i.variant.slice(0, 200), image: safeImage(i.image), price: i.price}));
        const selectedOffer = this.c.offers.find(o => o.id === s.offer);
        this.state = {offer: s.offer, items: items.slice(0, selectedOffer.count)};
      } catch {}
    }
    save() { try { localStorage.setItem(this.key, JSON.stringify(this.state)); } catch { this.say(this.t.storage); } }
    say(text, error = false) {
      const box = this.root.querySelector('[data-deal-feedback]');
      box.textContent = text;
      box.classList.toggle('wd-error', error);
    }
    async click(e) {
      const button = e.target.closest('button');
      if (!button || !this.root.contains(button)) return;
      if (button.matches('[data-deal-offer]')) await this.switchOffer(button.dataset.dealOffer);
      if (button.matches('[data-deal-add]')) this.add(button);
      if (button.matches('[data-deal-remove]')) {
        this.state.items.splice(Number(button.dataset.dealRemove), 1);
        this.save(); this.update(); this.say(this.t.removed);
      }
      if (button.matches('[data-deal-checkout]')) await this.checkout();
      if (button.matches('[data-deal-single]')) await this.single(button);
    }
    confirmChange(message = this.t.switchWarning, accept = this.t.switchYes) {
      return new Promise(resolve => {
        const d = document.createElement('dialog'); d.className = 'wd-dialog';
        const p = document.createElement('p'); p.textContent = message; d.append(p);
        const yes = document.createElement('button'); yes.type = 'button'; yes.className = 'wd-button'; yes.textContent = accept;
        const no = document.createElement('button'); no.type = 'button'; no.className = 'wd-button wd-button-outline'; no.textContent = this.t.cancel;
        let answered = false;
        const end = value => { if (answered) return; answered = true; d.close(); d.remove(); resolve(value); };
        yes.addEventListener('click', () => end(true)); no.addEventListener('click', () => end(false));
        d.addEventListener('cancel', e => { e.preventDefault(); end(false); });
        d.append(yes, no); document.body.append(d); d.showModal(); no.focus();
      });
    }
    async switchOffer(id) {
      const next = this.c.offers.find(o => o.id === id);
      if (!next || this.busy) return;
      if (this.state.items.length > next.count && !await this.confirmChange()) return;
      this.state.offer = id; this.state.items = this.state.items.slice(0, next.count);
      this.save(); this.update(); this.rewriteLinks();
    }
    currentVariant(product, card) {
      let id;
      if (this.c.mode === 'product') id = this.section?.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
      else id = card?.querySelector('[data-deal-variant]')?.value;
      return product?.variants.find(v => String(v.id) === String(id)) || product?.variants.find(v => v.available) || product?.variants[0];
    }
    add(button) {
      if (this.busy) return;
      const product = this.products.get(button.dataset.dealAdd);
      const variant = this.currentVariant(product, button.closest('[data-deal-card]'));
      if (!product || !variant?.available) return this.say(this.t.soldOut, true);
      if (this.state.items.length >= this.offer.count) return this.say(this.t.full, true);
      const selected = this.state.items.filter(i => i.id === variant.id).length;
      if (variant.limit !== null && selected >= variant.limit) return this.say(this.t.stock, true);
      this.state.items.push({id: variant.id, productId: product.id, handle: product.handle, title: product.title, variant: variant.title, image: safeImage(product.image), price: variant.price});
      this.save(); this.update(); this.say(this.t.added.replace('{name}', product.title));
    }
    updateProductButton() {
      if (this.c.mode !== 'product') return;
      const product = this.c.products[0], variant = this.currentVariant(product);
      this.root.querySelectorAll('[data-deal-add],[data-deal-single]').forEach(b => { b.disabled = this.busy || !variant?.available; });
    }
    variantChanged(card) {
      if (!card) return;
      const p = this.products.get(card.dataset.dealCard), v = this.currentVariant(p, card);
      card.querySelector('.wd-card-price').textContent = this.money(v.price);
      card.querySelector('.wd-card-colour').textContent = v.title === 'Default Title' ? '' : v.title;
      card.querySelector('[data-deal-add]').disabled = this.busy || !v.available;
    }
    update() {
      const offer = this.offer, count = this.state.items.length;
      this.root.querySelectorAll('[data-deal-offer]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.dealOffer === offer.id)));
      this.root.querySelector('[data-deal-name]').textContent = offer.name;
      this.root.querySelector('[data-deal-progress]').textContent = this.t.progress.replace('{count}', count).replace('{total}', offer.count);
      this.root.querySelector('[data-deal-total]').textContent = this.money(offer.price);
      const slots = this.root.querySelector('[data-deal-slots]'); slots.replaceChildren();
      for (let i = 0; i < offer.count; i++) {
        const item = this.state.items[i], slot = document.createElement('div'); slot.className = 'wd-slot';
        if (item) {
          if (item.image) { const img = document.createElement('img'); img.src = item.image; img.width = 64; img.height = 64; img.alt = item.title + ' ' + item.variant; slot.append(img); }
          else { const label = document.createElement('span'); label.textContent = item.title; slot.append(label); }
          const b = document.createElement('button'); b.type = 'button'; b.dataset.dealRemove = i; b.textContent = '×'; b.setAttribute('aria-label', this.t.remove.replace('{name}', item.title)); slot.append(b);
          slot.title = item.title + ' · ' + item.variant;
        } else { slot.classList.add('wd-slot-empty'); slot.textContent = '+'; slot.setAttribute('aria-label', this.t.emptySlot); }
        slots.append(slot);
      }
      this.root.querySelector('[data-deal-tray]').hidden = false;
      const checkout = this.root.querySelector('[data-deal-checkout]');
      checkout.disabled = this.busy || count !== offer.count || !this.c.ready;
      checkout.textContent = this.busy ? this.t.adding : count !== offer.count ? this.t.chooseMore.replace('{count}', offer.count - count) : !this.c.ready ? this.t.comingSoon : this.t.addDeal.replace('{count}', offer.count);
      const onward = this.root.querySelector('[data-deal-continue]'); onward.href = this.link(this.c.url); onward.hidden = this.c.mode !== 'product';
      this.root.querySelectorAll('[data-deal-card]').forEach(card => {
        const added = this.state.items.filter(i => String(i.productId) === card.dataset.dealCard).length;
        card.classList.toggle('wd-card-selected', added > 0);
        const label = card.querySelector('[data-deal-added]'); label.hidden = !added; label.textContent = this.t.selected.replace('{count}', added);
      });
      this.updateProductButton();
    }
    link(url) {
      const target = new URL(url, location.origin);
      target.searchParams.set('deal', this.offer.id);
      const here = new URL(location.href), preview = here.searchParams.get('preview_theme_id');
      if (preview) target.searchParams.set('preview_theme_id', preview);
      return target.pathname + target.search + target.hash;
    }
    rewriteLinks() {
      this.root.querySelectorAll('[data-watch-link],[data-deal-back]').forEach(a => { a.href = this.link(a.getAttribute('href')); });
      this.root.querySelectorAll('.wd-pagination a').forEach(a => { const u = new URL(a.href); const view = new URL(location.href).searchParams.get('view'); if (view) u.searchParams.set('view', view); a.href = this.link(u.href); });
    }
    filter(query) {
      let visible = 0; query = query.toLowerCase().trim();
      this.root.querySelectorAll('[data-deal-card]').forEach(card => { card.hidden = !card.dataset.dealSearchText.includes(query); if (!card.hidden) visible++; });
      this.root.querySelector('[data-deal-no-results]').hidden = visible > 0;
    }
    async request(path, body) {
      const base = this.c.root.endsWith('/') ? this.c.root : this.c.root + '/';
      const response = await fetch(base + path, {method: body ? 'POST' : 'GET', headers: {'Accept': 'application/json', ...(body ? {'Content-Type': 'application/json'} : {})}, ...(body ? {body: JSON.stringify(body)} : {})});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || this.t.failed);
      return data;
    }
    async checkout() {
      if (this.busy || !this.c.ready || this.state.items.length !== this.offer.count) return;
      this.busy = true; this.update(); this.say(this.t.checking);
      try {
        const fresh = new Map(await Promise.all([...new Set(this.state.items.map(i => i.handle))].map(async h => [h, await this.request('products/' + encodeURIComponent(h) + '.js')])));
        const counts = new Map();
        for (const item of this.state.items) {
          const product = fresh.get(item.handle), variant = product.variants.find(v => v.id === item.id);
          if (!variant?.available) throw new Error(this.t.changedStock);
          if (variant.price !== 180000) throw new Error(this.t.changedPrice);
          counts.set(item.id, (counts.get(item.id) || 0) + 1);
        }
        const cart = await this.request('cart.js');
        const old = cart.items.filter(i => i.properties?._bagspot_deal);
        if (old.length) {
          if (!await this.confirmChange(this.t.replaceWarning, this.t.replaceYes)) return;
          const updates = Object.fromEntries(old.map(i => [i.key, 0]));
          await this.request('cart/update.js', {updates});
        }
        const bundle = typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2);
        await this.request('cart/add.js', {items: [...counts].map(([id, quantity]) => ({id, quantity, properties: {'Watch deal reference': bundle.slice(0, 8), '_bagspot_deal': bundle, '_bagspot_deal_size': String(this.offer.count)}}))});
        this.state.items = []; this.save(); location.assign(this.link(this.c.root + 'cart'));
      } catch (error) { this.say(error.message || this.t.failed, true); }
      finally { this.busy = false; this.update(); }
    }
    async single(button) {
      if (this.busy) return;
      const variant = this.currentVariant(this.c.products[0]);
      if (!variant?.available) return;
      this.busy = true; this.updateProductButton(); button.textContent = this.t.adding;
      try { await this.request('cart/add.js', {items: [{id: variant.id, quantity: 1}]}); location.assign(this.link(this.c.root + 'cart')); }
      catch (error) { this.say(error.message || this.t.failed, true); }
      finally { this.busy = false; button.textContent = this.t.buySingle; this.updateProductButton(); }
    }
  }
  const init = scope => scope.querySelectorAll('[data-watch-deal-root]').forEach(root => { if (root.dataset.ready) return; try { controllers.add(new WatchDeals(root)); } catch (error) { console.error('Watch deal initialization failed', error); } });
  window.BagspotWatchDeals = {init};
  window.addEventListener('storage', e => controllers.forEach(c => { if (e.key === c.key) { c.load(); c.update(); c.rewriteLinks(); } }));
  window.addEventListener('pageshow', () => controllers.forEach(c => { c.load(); c.update(); }));
  document.addEventListener('shopify:section:load', e => init(e.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once: true}); else init(document);
})();
